<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{route.menuName}}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="发票登记单号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else>发票登记单号:{{ form.no }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="申请时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>申请时间:{{  parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" label="申请人" v-if="getIsView()">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>申请人:{{ form.createdUserName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="ownerDeptName" label="所属科室" v-if="getIsView()">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>所属科室:{{ form.ownerDeptName }} </span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="supplierName" label="供应商" v-if="getIsView()">
                <el-select v-model="form.supplierName" :disabled="!editMode" placeholder="请选择供应商" filterable :filter-method="getSuppliers" @change="supplierChange" style="width:100%">
                  <el-option key="0" label="请选择供应商" value></el-option>
                  <el-option v-for="item in STATIC_Suppliers" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>供应商:{{ form.supplierName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="category" label="开票类型" v-if="getIsView()">
                <el-select v-model="form.category" placeholder="请选择" :disabled="!editMode" @change="categoryChange" style="width:100%">
                  <el-option v-for="item in billCategory" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>开票类型:{{ billCategory.find(item => item.id == form.category)?.name }} </span>
            </el-col>
            <el-col v-if="form.category != 2" :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="tableCategory" label="单据类型" v-if="getIsView()">
                <el-select v-model="form.tableCategory" placeholder="请选择" :disabled="!editMode" @change="categoryChange" style="width:100%">
                  <el-option v-for="item in billTableCategory" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>单据类型:{{ billTableCategory.find(item => item.id == form.tableCategory)?.name }} </span>
            </el-col>
            <el-col v-if="form.category != 2 && form.tableCategory==0" :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="acceptInStockIdArr" label="采购入库" v-if="getIsView()">
                <el-select v-model="form.acceptInStockIdArr" placeholder="请选择" :disabled="!editMode" multiple collapse-tags filterable :filter-method="getAcceptInStockList" @change="acceptInStockChange" style="width:100%">
                  <el-option v-for="item in acceptInStockList" :key="item.id" :label="item.no" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>采购入库:{{ acceptInStockName }} </span>
            </el-col>
            <el-col v-if="form.category != 2 && form.tableCategory==1" :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="acceptOutStockIdArr" label="采购退货" v-if="getIsView()">
                <el-select v-model="form.acceptOutStockIdArr" placeholder="请选择" :disabled="!editMode" multiple collapse-tags filterable :filter-method="getAcceptOutStockList" @change="acceptOutStockChange">
                  <el-option v-for="item in acceptOutStockList" :key="item.id" :label="item.no" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>采购退货:{{ acceptInStockName }} </span>
            </el-col>
            <el-col v-if="form.category==2" :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="purchaseDistributeNo" label="配送单号" v-if="getIsView()">
                <el-input disabled v-model="form.purchaseDistributeNo"></el-input>
              </el-form-item>
              <span class="viewText" v-else>配送单号:{{ form.purchaseDistributeNo }} </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalAmount" label="开票总金额" v-if="getIsView()">
                <el-input disabled v-model="form.totalAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>开票总金额:{{ form.totalAmount }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="billCode" label="发票代码" v-if="getIsView()">
                <el-input :disabled="!editMode" v-model="form.billCode"></el-input>
              </el-form-item>
              <span class="viewText" v-else>发票代码:{{ form.billCode }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="billNo" label="发票号码" v-if="getIsView()">
                <el-input :disabled="!editMode" v-model="form.billNo"></el-input>
              </el-form-item>
              <span class="viewText" v-else>发票号码:{{ form.billNo }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="stateName" label="状态" v-if="getIsView()">
                <el-input disabled v-model="form.stateName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>状态:{{ form.stateName }} </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="receivedAmount" label="已付款金额" v-if="getIsView()">
                <el-input disabled v-model="form.receivedAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>已付款金额:{{ form.receivedAmount }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="unReceivedAmount" label="未付款金额" v-if="getIsView()">
                <el-input disabled v-model="form.unReceivedAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>未付款金额:{{ form.unReceivedAmount }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="remark" label="备注" v-if="getIsView()">
                <el-input :disabled="!editMode" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else>备注:{{ form.remark }} </span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">产品明细</span>
          </div>

          <div style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column prop="productName" label="产品名称" />
            <el-table-column prop="specName" label="规格型号" />
            <el-table-column prop="number" label="数量" />
            <el-table-column prop="price" label="单价" />
            <el-table-column prop="amount" label="金额" />
            <el-table-column prop="taxRate" label="税率">
              <template slot-scope="scope">
                <el-select v-model="scope.row.taxRate" :disabled="!editMode" placeholder="请选择税率" @change="taxChange(scope.row)">
                  <el-option v-for="item in taxList" :key="item.id" :label="item.name + '%'" :value="item.id"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="taxAmount" label="税额" />
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  GetBillRegisterById,
  SaveBillRegister,
  RejectBillRegister,
  GetAcceptInStocks,
  GetAcceptOutStocks,
  GetAcceptInStockById,
  GetAcceptOutStockById
} from "@/api";
import { BillTaxOptions, BillCategory, BillTableCategory } from "@/enum";
import ApproveInfo from "@/components/approve-info";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    ApproveInfo,
  },
  data () {
    return {
      GetDataAction: GetBillRegisterById,
      SaveDataAction: SaveBillRegister,
      reject: RejectBillRegister,
      form: {},

      taxList: BillTaxOptions,
      billCategory: BillCategory,
      billTableCategory: BillTableCategory,
      rules: {
        supplierName: [
          { required: true, message: '请选择供应商', trigger: 'blur' }
        ],
        billCode: [
          { required: true, message: '请选择发票代码', trigger: 'blur' }
        ],
        billNo: [
          { required: true, message: '请选择发票号码', trigger: 'blur' }
        ],
      },

      editMode: false,
      showWorkFlowInfo: false,

      acceptInStockIds: [],
      acceptOutStockIds: [],
      acceptInStockList: [],
      acceptOutStockList: [],
      defaultTaxRate: 13,
      acceptInStockName: '',
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    if (query.isCopy == 1) {
      this.isCopy = true
    }

    // if (query.editMode == 1) {
    //   this.editMode = true
    // }

    this.getAcceptInStockList('')
    this.getSuppliers('')
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.getLocations(this.form.warehouseId);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.getAcceptInStockName()

        this.initWorkFlowProperty(this.form);

        let acceptInStockIds = []
        if (this.form.acceptInStockInfos) {
          this.form.acceptInStockInfos.map(item => {
            acceptInStockIds.push(item.id)
            var arr = this.acceptInStockList.filter(e => e.id == item.id)
            if (!arr || arr.length == 0) {
              this.acceptInStockList.push(item)
            }
          })
        }
        this.form.acceptInStockIdArr = acceptInStockIds
        let acceptOutStockIds = []
        if (this.form.acceptOutStockInfos) {
          this.form.acceptOutStockInfos.map(item => {
            acceptOutStockIds.push(item.id)
            var arr = this.acceptOutStockList.filter(e => e.id == item.id)
            if (!arr || arr.length == 0) {
              this.acceptOutStockList.push(item)
            }
          })
        }

        this.form.acceptOutStockIdArr = acceptOutStockIds

      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.SaveDataAction(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      this.form = {
        "acceptInStockNo": "",
        tableCategory: 0,
        category: 0,
        state: 0,
        supplierName: '',
        supplierId: '',
        receivedAmount: 0,
        unReceivedAmount: 0,
        details: [],
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode :sessionStorage.getItem('orgId')
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm () {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();

      this.getProductList('')
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        "supplierProductId": '',
        productName: '',
        productId: '',
        "specId": '',
        "brand": "",
        "supplierId": '',
        "manufacturerId": '',
        "unit": "",
        "minUnit": "",
        "stockNumber": 0,
        oneLevelStockNumber: 0,
        "number": 0,
        "price": 0,
        "amount": 0,
        remark: '',
        isHaveStock: true,
        packSpec: '',
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.pushChildForm(true);
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();

      this.getProductList('')
    },
    pushChildForm (close) {
      this.$refs["childForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        // this.capitalSourceChange()
        let item = this.form.details.find(
          (e) =>
            e.$index != this.childForm.$index &&
            e.supplierProductId == this.childForm.supplierProductId //&&
          // e.price == this.childForm.price &&
          // e.locationName == this.childForm.locationName &&
          // e.assetSource == this.childForm.assetSource &&
          // e.packDesc == this.childForm.packDesc &&
          // e.manufacturerId == this.childForm.manufacturerId &&
          // e.certId == this.childForm.certId &&
          // e.brandId == this.childForm.brandId
        );
        if (item && !this.editChildren) {
          // 新增有重复项提示
          // Object.assign(item, this.childForm);
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (item && this.editChildren) {
          // 编辑且有重复项
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (!item && this.editChildren) {
          // 编辑
          item = this.form.details.find(
            (e) => e.$index == this.childForm.$index
          );
          Object.assign(item, this.childForm);
        } else {
          this.form.details.push(this.childForm);
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
        }
      });
    },
    childNumberChange () {
      this.childForm.notReceivedNumber = this.childForm.number
      this.childForm.planOrderNumber = this.childForm.number
      this.childForm.actualOrderNumber = this.childForm.number
      this.autoAmount();
    },
    autoAmount () {
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(4) * 1;
      this.childForm.unBillAmount = this.childForm.amount;
    },
    autoTotalAmount () {
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        totalAmount = totalAmount + element.amount;
      });
      this.form.totalAmount = totalAmount.toFixed(4) * 1
      this.form.unReceivedAmount = totalAmount.toFixed(4) * 1
    },

    // change event
    supplierChange (val) {
      this.form.supplierId = val
      this.categoryChange()
      this.getAcceptInStockList('')
      this.getAcceptOutStockList('')
    },
    categoryChange (val) {
      this.acceptInStockIds = []
      this.acceptOutStockIds = []
      this.form.acceptInStockIds = ''
      this.form.acceptInStockIdArr = []
      this.form.acceptOutStockIdArr = []
      this.form.acceptOutStockIds = ''
      this.form.totalAmount = 0
      this.form.unReceivedAmount = 0
      this.form.details = []
    },
    acceptInStockChange (val) {
      this.form.acceptInStockIds = val.join(';')
      // 取出新增的值
      for (let i = 0; i < val.length; i++) {
        if (this.acceptInStockIds.indexOf(val[i]) == -1) {
          this.addDetails(val[i], GetAcceptInStockById)
        }
      }

      // 取出减少的值
      for (let i = 0; i < this.acceptInStockIds.length; i++) {
        if (val.indexOf(this.acceptInStockIds[i]) == -1) {
          this.removeDetails(this.acceptInStockIds[i], GetAcceptInStockById)
        }
      }

      this.acceptInStockIds = val
    },
    acceptOutStockChange (val) {
      this.form.acceptOutStockIds = val.join(';')
      // 取出新增的值
      for (let i = 0; i < val.length; i++) {
        if (this.acceptOutStockIds.indexOf(val[i]) == -1) {
          this.addDetails(val[i], GetAcceptOutStockById)
        }
      }

      // 取出减少的值
      for (let i = 0; i < this.acceptOutStockIds.length; i++) {
        if (val.indexOf(this.acceptOutStockIds[i]) == -1) {
          this.removeDetails(this.acceptOutStockIds[i], GetAcceptOutStockById)
        }
      }

      this.acceptOutStockIds = val
    },
    addDetails (val, fn) {
      if (val) {
        fn({ id: val })
          .then(res => {
            let details = res.returnData.details
            if (!details) return
            // 按明细
            if (this.form.category == 0) {
              details.map(item => {
                let detail = {
                  applyId: val,
                  productId: item.productId,
                  specId: item.specId,
                  productName: item.productName,
                  specName: item.specName,
                  number: item.number,
                  price: item.price,
                  amount: item.amount,
                  taxRate: this.defaultTaxRate,
                  taxAmount: (item.amount * this.defaultTaxRate / 100).toFixed(3) * 1
                }
                if (this.form.tableCategory == 1) {
                  detail.number = -detail.number
                  detail.amount = -detail.amount
                  detail.taxAmount = -detail.taxAmount
                }
                this.form.details.push(detail)
              })
            }
            // 按汇总
            else if (this.form.category == 1) {
              details.map(item => {
                let detailList = this.form.details.filter(e => e.productId == item.productId && e.specId == item.specId && e.price == item.price)
                if (detailList && detailList.length > 0) {
                  let detail = detailList[0]
                  if (this.form.tableCategory == 1) {
                    detail.number -= item.number
                    detail.amount -= item.amount
                    detail.taxAmount = (detail.amount * detail.taxRate / 100).toFixed(3) * 1
                  }
                  else {
                    detail.number += item.number
                    detail.amount += item.amount
                    detail.taxAmount = (detail.amount * detail.taxRate / 100).toFixed(3) * 1
                  }
                }
                else {
                  let detail = {
                    applyId: val,
                    productId: item.productId,
                    specId: item.specId,
                    productName: item.productName,
                    specName: item.specName,
                    number: item.number,
                    price: item.price,
                    amount: item.amount,
                    taxRate: this.defaultTaxRate,
                    taxAmount: (item.amount * this.defaultTaxRate / 100).toFixed(3) * 1
                  }
                  if (this.form.tableCategory == 1) {
                    detail.number = -detail.number
                    detail.amount = -detail.amount
                    detail.taxAmount = -detail.taxAmount
                  }

                  this.form.details.push(detail)
                }
              })
            }
            this.autoTotalAmount()
          })
      }
    },
    removeDetails (val, fn) {
      if (val) {
        // 按明细
        if (this.form.category == 0) {
          this.form.details = this.form.details.filter(item => item.applyId != val)
          this.autoTotalAmount()
        }
        else if (this.form.category == 1) {
          fn({ id: val })
            .then(res => {
              let details = res.returnData.details
              if (!details) return
              details.map(item => {
                let detailList = this.form.details.filter(e => e.productId == item.productId && e.specId == item.specId && e.price == item.price)
                if (detailList && detailList.length > 0) {
                  let detail = detailList[0]
                  if (this.form.tableCategory == 1) {
                    detail.number += item.number
                    detail.amount += item.amount
                    detail.taxAmount = (detail.amount * detail.taxRate / 100).toFixed(3) * 1
                  }
                  else {
                    detail.number -= item.number
                    detail.amount -= item.amount
                    detail.taxAmount = (detail.amount * detail.taxRate / 100).toFixed(3) * 1
                  }

                  if (detail.number == 0 && detail.amount == 0) {
                    this.form.details.remove(detail)
                  }
                }
                else {
                  let detail = {
                    applyId: val,
                    productId: item.productId,
                    specId: item.specId,
                    productName: item.productName,
                    specName: item.specName,
                    number: -item.number,
                    price: item.price,
                    amount: -item.amount,
                    taxRate: this.defaultTaxRate,
                    taxAmount: (item.amount * this.defaultTaxRate / 100).toFixed(3) * 1
                  }
                  if (this.form.tableCategory == 1) {
                    detail.number = detail.number
                    detail.amount = detail.amount
                    detail.taxAmount = detail.taxAmount
                  }
                  this.form.details.push(detail)
                }
              })

              this.autoTotalAmount()
            })
        }
      }
    },
    taxChange (row) {
      row.taxAmount = (row.amount * row.taxRate / 100).toFixed(3) * 1
    },



    getAcceptInStockList (keyWord) {
      GetAcceptInStocks({ keyWord: keyWord, pageIndex: 1, pageSize: 100, isBill: 1, supplierId: this.form.supplierId })
        .then(res => {
          this.acceptInStockList = res.returnData.data
        })
    },
    getAcceptOutStockList (keyWord) {
      GetAcceptOutStocks({ keyWord: keyWord, pageIndex: 1, pageSize: 100, isBill: 1, supplierId: this.form.supplierId })
        .then(res => {
          this.acceptOutStockList = res.returnData.data
        })
    },
    getAcceptInStockName () {
        this.$nextTick(()=>{
          if(this.form.acceptOutStockInfos.length>0){
            this.acceptInStockName = this.form.acceptOutStockInfos.map(item=>item.no).join('、')
          }else{
          this.acceptInStockName = this.form.acceptInStockInfos.map(item=>item.no).join('、')

          }
          
        })
    },
  },  
};
</script>

<style lang="scss" scoped>
// /deep/.el-dialog__body {
//   overflow: auto !important;
// }
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
